import { useFormikContext } from "formik";
import useGetHasValueCount from "./useGetHasValueCount";

function useGetHasValueCountWithContext<T extends Record<string, any>>() {
  const formikValues = useFormikContext<T>();
  const { getHasValueCount } = useGetHasValueCount<T>(formikValues?.values);

  return {
    getHasValueCount,
  };
}

export default useGetHasValueCountWithContext;
